import { render, staticRenderFns } from "./AlipayRecord.vue?vue&type=template&id=06a6068e&scoped=true&"
import script from "./AlipayRecord.vue?vue&type=script&lang=js&"
export * from "./AlipayRecord.vue?vue&type=script&lang=js&"
import style0 from "./AlipayRecord.vue?vue&type=style&index=0&id=06a6068e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a6068e",
  null
  
)

export default component.exports